function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState } from 'react';
import { connect } from 'react-redux';
import { modalActions } from '../../reducers/modal.reducer';
import Table from '../common/table/Table.react';
import Card from '../common/card/Card.react';
import CardHeader from '../common/card/CardHeader.react';
import ContactsAdd from './ContactsAdd.modal';
var ContactsTable = function ContactsTable(_ref) {
  var cmsContacts = _ref.cmsContacts,
    addModalAction = _ref.addModalAction;
  var navigate = useNavigate();
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    filter = _useState2[0],
    setFilter = _useState2[1];
  var formatNumber = function formatNumber(_ref2) {
    var type = _ref2.type,
      number = _ref2.number;
    return "".concat(type === 'tel' ? 'P: ' : 'F: ', " ").concat(number.replace(/(\d{3})(\d{3})(\d{4})/, '$1.$2.$3'));
  };
  var dict = {
    'page-item-contact': 'Section Contact Slide-out',
    'contact-info': 'Contact Info',
    'office-locations': 'Office Location',
    'business-units': 'Business Units',
    contacts: 'Contacts',
    departments: 'Departments'
  };
  var tableData = {
    columns: {
      id: {
        title: '_id',
        visible: false
      },
      title: 'Title',
      name: 'Contact Person',
      numbers: {
        title: 'Numbers',
        render: function render(row) {
          var _row$numbers;
          return /*#__PURE__*/React.createElement("div", null, (_row$numbers = row.numbers) === null || _row$numbers === void 0 ? void 0 : _row$numbers.map(function (x) {
            return /*#__PURE__*/React.createElement("div", {
              key: x._id
            }, formatNumber(_objectSpread({}, x)));
          }));
        }
      },
      emails: {
        title: 'Emails',
        render: function render(row) {
          var _row$emails;
          return /*#__PURE__*/React.createElement("div", null, (_row$emails = row.emails) === null || _row$emails === void 0 ? void 0 : _row$emails.map(function (x) {
            return /*#__PURE__*/React.createElement("div", {
              key: x._id
            }, x.address);
          }));
        }
      },
      address: {
        title: 'Address',
        render: function render(row) {
          return /*#__PURE__*/React.createElement("div", null, row.address && row.address.length > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", null, row.address[0].street), /*#__PURE__*/React.createElement("div", null, row.address[0].city, ", ", row.address[0].state, ", ", row.address[0].zip)));
        }
      },
      contactType: 'Contact Type'
    },
    data: Object.values(cmsContacts).map(function (x) {
      return {
        id: x._id,
        title: x.title,
        name: x.name,
        numbers: x.numbers,
        emails: x.emails,
        address: x.address,
        contactType: dict[x.contactType] || ''
      };
    })
  };
  return /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardHeader, {
    title: "Contacts",
    button: {
      label: 'Add Contact',
      type: 'add',
      permission: 'edit-pos-contacts',
      onClick: function onClick() {
        addModalAction({
          component: /*#__PURE__*/React.createElement(ContactsAdd, null)
        });
      }
    },
    search: {
      query: filter,
      onChange: function onChange(e) {
        return setFilter(e.target.value);
      },
      label: 'Search Contacts:',
      placeholder: 'Search...'
    }
  }), /*#__PURE__*/React.createElement(Table, _extends({}, tableData, {
    sort: {
      by: 'title'
    },
    filter: filter,
    filterColumns: ['title', 'name', 'emails'],
    tr: {
      onClick: function onClick(row) {
        return navigate("/contact/".concat(row.id));
      }
    }
  })));
};
var mdtp = {
  addModalAction: modalActions.add
};
export default connect(null, mdtp)(ContactsTable);